import { createAppConstants } from '@hwm/ui-lib';

export const styleConstants = createAppConstants(
  {},
  {
    borderRadius: '8px',
    colors: {
      primaryColor: '#00A9E0',
      primaryDark: '#002F6C',
      secondaryColor: '#596794',
      warningColor: '#DF7C1F',
      inputBg: '#E1E1E1',
      investigationNew: '#429ECB',
      investigationOngoing: '#555555',
      investigationCleared: '#DDDDDD',
      maintenanceRequired: '#E0C91D',
      statusOk: '#5ABF8A',
      statusOkLight: '#E3FBEE',
      statusWarning: '#DF7C1E',
      statusWarningLight: '#FFE2C6',
      statusFlood: '#C2224F',
      statusFloodLight: '#F9C7D6',
      statusQuiet: '#6175B6',
      green: '#5ABF8A',
      gray: '#57595D',
      white: '#ffffff',
      foulPipe: '#665247',
      surfacePipe: '#628ba8',
      egdedShape: '#9E9E9E',
      disabledBackground: '#F0F1F5',
      fault: '#444649',
      purple: '#541675',
      common: '#182038',
    },
  }
);
